module.exports = __webpack_public_path__ + "media/icons/hand-pointing-4c6fa017.svg";